(function(angular) {
    'use strict';

    angular.module('aprima-legacy-common').factory('ErrorService', [
        '_',
        'aprgettext',
        'RequestTypes',
        'toaster',
        ErrorService,
    ]);

    function ErrorService(
        _,
        gettext,
        RequestTypes,
        toaster
    ) {

        return {
            convertToErrorMessages: convertToErrorMessages,
            displayErrorMessages: displayErrorMessages,
            addHttpErrorToScope: addHttpErrorToScope,
            removeHttpErrorFromScope: removeHttpErrorFromScope,
        };

        // This can't be moved to Angular because it's relying on translations being returned synchronously.
        function convertToErrorMessages(error) {
            var errors = [];

            if (!error) {
                errors.push(getGenericError());
                return errors;
            }

            if(_.isString(error)) {
                errors.push(error);
                return errors;
            }

            var modelState = (error.data && error.data.ModelState) || error.ModelState;
            if (modelState) {
                _(modelState)
                    .flatMap(function(value) {
                        return value || [];
                    })
                    .forEach(function (err) {
                        errors.push(gettext(err));
                    });

                if (errors.length) {
                    return errors;
                }
            }

            var validationResult = (error.data && error.data.ValidationResult) || error.ValidationResult;
            if (validationResult && !validationResult.IsValid) {
                _(validationResult.Errors)
                    .forEach(function (err) {
                        errors.push(gettext(err.ErrorMessage));
                    });

                if (errors.length) {
                    return errors;
                }
            }

            if (error.status && error.statusText) {
                errors.push(gettext('An error has occurred. Status: ' + error.status + ': ' + error.statusText));
            }
            else {
                var genericError = getGenericError();
                if(error.Message) {
                    genericError += ' ' + error.Message;
                }
                errors.push(genericError);
            }
            return errors;
        }

        function displayErrorMessages(error, asHtml) {
            var errors = _.isArray(error) ? error : convertToErrorMessages(error);

            errors.forEach(function (err) {
                toaster.pop({
                    type: 'error',
                    title: '',
                    body: err,
                    bodyOutputType: asHtml ? 'trustedHtml' : '',
                });
            });

            return errors;
        }

        function getGenericError() {
            return gettext('An error has occurred and the process cannot be completed.');
        }

        function addHttpErrorToScope(scope, httpResponse, messages, type) {
            var error = { type: type || RequestTypes.default };
            var key = 'is' + httpResponse.status;
            error[key] = true;
            error.reason = messages && messages[key];

            if (httpResponse.status === 403) {
                error.responseMessage = httpResponse.headers()['reason-phrase'];
            }
            else {
                error.unhandled = true;
            }

            error.reason = error.reason || error.responseMessage;

            scope.httpError = error;

            return error;
        }

        function removeHttpErrorFromScope(scope, type) {
            //only remove it if on this specific scope. This avoids nulling in higher level scopes
            //only remove matching types of httpError's
            if (scope.hasOwnProperty('httpError') && scope.httpError && ((!type && scope.httpError.type === RequestTypes.default) || scope.httpError.type === type)) {
                scope.httpError = null;
            }
        }
    }

})(window.angular);
